import { createSelector } from 'reselect';
import { RootState } from 'store';

export const getToErrorPage = createSelector(
  ({ toErrorPage }: RootState) => toErrorPage,
  (toErrorPage) => toErrorPage,
);
